<res-base-modal [modalTitle]="modalTitle" [modalAutomationId]="modalAutomationId" (closeButtonActionEmt)="closeModal()"
    [secondaryButtonLabel]="secondaryButtonLabel" [modalHelpIndex]="modalHelpIndex" [modalClass]="modalClass"
    [isPrimaryButtonHidden]="true" [modalDraggable]=false >
    <res-generic-grid [gridName]="gridName" [automationId]="modalAutomationId" [(isBusy)]="isBusy" [(isBusyMessage)]="isBusyMessage"
        [columnDefs]="columnDefs" [requestInfo]="requestInfo" [pagerTemplate]="pagerTemplate">
    </res-generic-grid>
    <ng-template #pagerTemplate>
        <button class="secondary-button icon-button borderless-button" (click)="downloadCSV()"
            [attr.data-automation-id]="modalAutomationId + '-download-button'" [attr.title]="'Download (.csv)'">
            <i class="fa fa-download color-blue-01"></i>
        </button>
    </ng-template>
</res-base-modal>